// API 網址
export const API_BASE_URL = '/api/';
